import * as HttpService from "../../../../service/HttpService"


/** 系统管理  -> 单位管理服务 **/

/**
 *  获取单位列表
 * @param parentOrgNo 父单位编号
 */
export const getOrgList = (parentOrgNo) => {
    const param = parentOrgNo == null ? "" : "parentOrgNo=" + parentOrgNo
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/orgmgmt/child/list?" + param);
}

/**
 * 获取单位或部门下的children
 * @param parentOrgNo 父级id
 * @param type 父级类型
 */
export const orgDeptList = (parentOrgNo, type) => {
    parentOrgNo = parentOrgNo || "";
    type = type || 0;
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/orgmgmt/child/orgAndDeptList?type="+ type +"&parentNo=" + parentOrgNo);
}

/**
 *  组织单位删除
 * @param orgNo 组织编号
 * @param type 类型
 */
export const orgDeptDelete = (orgNo, type) => {
    switch (type) {
        case 0: return deleteOrg(orgNo);
        case 1: return deleteDept(orgNo);
    }
}

/**
 * 组织单位编辑
 * @param org 组织对象
 * @param type 类型
 * @returns {Promise<Response>}
 */
export const orgDeptEdit = (org, type) => {
    switch (type) {
        case 0: return editOrg(org);
        case 1:
            const dept = {
                deptNo: org.orgNo,
                deptAbbr: org.orgAbbr,
                deptDesc: org.orgDesc,
                deptName: org.orgName,
                sortSn: org.sortSn
            }
            return editDept(dept);
    }
}
/**
 * 组织单位添加
 * @param org 属性对象
 * @param type 类型
 */
export const orgDeptAdd = (org, type) => {
    const orgNo = org.parentType == 0 ? org.parentOrgNo : "";
    const parentDeptNo = org.parentType == 1 ? org.parentOrgNo : "";
    switch (type) {
        case 0: return addOrg(org);
        case 1:
            const dept = {
                deptAbbr: org.orgAbbr,
                deptDesc: org.orgDesc,
                deptName: org.orgName,
                orgNo: orgNo,
                parentDeptNo: parentDeptNo,
                sortSn: org.sortSn
            }
            return addDept(dept);
    }
}

/**
 * 删除单位
 * @param orgNo 单位编号
 */
export const deleteOrg = (orgNo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/orgmgmt/deleteOrg/" + orgNo);
}


/**
 * 新增单位
 * @param orgNo 单位编号
 */
export const addOrg = (org) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/orgmgmt/addOrgDo",  org);
}

/**
 * 编辑单位
 */
export const editOrg = (org) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/orgmgmt/editOrgDo", org);
}

/**
 * 新增部门
 */
export const addDept = (dept) => {
    return HttpService.post(HttpService.DOMAIN +  "/sysmgmt/deptmgmt/addDeptDo", dept);
}

/**
 * 编辑部门
 */
export const editDept = (dept) => {
    return HttpService.post(HttpService.DOMAIN +  "/sysmgmt/deptmgmt/editDeptDo", dept);
}

/**
 * 删除部门
 */
export const deleteDept = (deptNo) => {
    return HttpService.post(HttpService.DOMAIN +  "/sysmgmt/deptmgmt/deleteDept/" + deptNo);
}

/**
 * 新增组织logo
 * @param orgNo 组织变化
 * @param logoUrl logoUrl logo地址
 */
export const addOrgLogo = (orgNo, logoUrl) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/orgExtMgmt/addOrgExtDo", {
        orgNo: orgNo,
        extAttrValue: logoUrl
    })
};

/**
 * 修改组织logo
 * @param orgNo 组织变化
 * @param logoUrl logoUrl logo地址
 */
export const editOrgLogo = (orgNo, logoUrl) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/orgExtMgmt/editOrgExtDo", {
        orgNo: orgNo,
        extAttrValue: logoUrl
    })
};
